import { extendTheme, themeTools } from 'native-base';
import { generatePalette } from '../Colors/Color';

import { SpinnerTheme } from "../Spinner/theme";
import { ButtonTheme } from '../Button/theme';
import { InputTheme } from '../Input/theme';
import { IconTheme } from '../Icon/theme';
import { DialogTheme } from "../Dialog/theme";
import { GridTheme } from "../Grid/theme";
import { ListTheme } from "../List/theme";
import { LinkTheme } from "../Link/theme";
import { MenuTheme } from '../Menu/theme';
import { DropdownTheme, TypeAheadSearchItemTheme } from '../Dropdown/theme';
import { SwitchTheme } from '../Switch/theme';
import { CheckboxTheme } from '../Checkbox/theme';
import { AccordionTheme } from "../Accordion/theme";
import { PressableTheme } from "../Pressable/theme";
import { RadioTheme } from '../Radio/theme';
import { PopoverTheme } from '../Popover/theme';


export const getTheme = (themeColor) => {
  return extendTheme({
    colors: {
      primary: generatePalette(themeColor),
    },
    fonts: {
      heading: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      body: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
      mono: undefined,
    },
    components: {
      FormControlLabel: {
        mb: 0,
        baseStyle: ( props) => ({
          _text: {
            color: themeTools.mode('muted.400', 'muted.400')(props),
            fontSize: 'xs',
          }
        }),
      },
      Icon: IconTheme,
      Select: DropdownTheme,
      TypeAheadSearchItem: TypeAheadSearchItemTheme,
      ...AccordionTheme,
      ...ButtonTheme,
      ...MenuTheme, 
      ...InputTheme,
      ...DialogTheme,
      ...GridTheme,
      ...SpinnerTheme,
      ...LinkTheme,
      ...ListTheme,
      ...SwitchTheme,
      ...CheckboxTheme,
      ...RadioTheme,
      ...PressableTheme,
      ...PopoverTheme
    },
    config: {
      // initialColorMode: "dark"
    }
  })
};